import React from "react";

import svg from "../../assets/images/icons/coding.svg";

export const CodingIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Coding"}
    />
);
